// TODO: Remove the any type and replace with a proper type.
import { Injectable } from '@angular/core';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from './firestore.service';
import type { TSkuAction } from '@shared/models';

@Injectable({
    providedIn: 'root'
})
export class SkuActionsService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public getNullable(): TSkuAction {
        const skuAction: TSkuAction = {
            sku: '',
            description: '',
            increaseExpiration: false,
            increaseExpirationDays: 0,
            increaseExpirationMonths: 0,
            increaseExpirationYears: 0,
            increasePremiumSupportMonths: 0,
            increasePremiumSupportYears: 0,
            increaseWebHostingMonths: 0,
            increaseWebHostingYears: 0,
            updateActivationInfo: false,
            updateCredits: false,
            updatePackageDetails: false,
            sendCompleteOrderEmail: false,
            type: '',
            uid: ''
        };
        return skuAction;
    }

    public async getByUid(uid: string): Promise<TSkuAction> {
        const path = this.firestorePathsService.getSkuActionsPath();
        const unk = await this.firestoreService.getByUid(path, uid);
        return unk as TSkuAction;
    }

    public getAll(): Promise<TSkuAction[]> {
        const path = this.firestorePathsService.getSkuActionsPath();
        return this.firestoreService.getAll(path) as Promise<TSkuAction[]>;
    }

    public add(item: TSkuAction) {
        const path = this.firestorePathsService.getSkuActionsPath();
        return this.firestoreService.add(path, item);
    }

    public async addAll(newSkus: TSkuAction[]): Promise<any> {
        if (newSkus.length === 0) {
            return;
        }

        const promises: Promise<any>[] = [];
        newSkus.forEach((item) => {
            const promise = this.set(item, item.sku);
            promises.push(promise);
        });
        return Promise.all(promises);
    }

    public set(item: TSkuAction, uid: string) {
        item.uid = uid;
        const collection = this.firestorePathsService.getSkuActionsPath();
        return this.firestoreService.set(collection, item);
    }

    public update(country: TSkuAction): Promise<TSkuAction> {
        const collection = this.firestorePathsService.getSkuActionsPath();
        return this.firestoreService.update(collection, country) as Promise<TSkuAction>;
    }

    public delete(uid: string): Promise<void> {
        const collection = this.firestorePathsService.getSkuActionsPath();
        return this.firestoreService.delete(collection, uid);
    }

    public sort(skuActions: TSkuAction[]): TSkuAction[] {
        const sorted = skuActions.sort((a, b) => ((a.sku > b.sku) ? 1 : -1));

        return sorted;
    }
}
